import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { api } from "@/lib/api";

// One tap when done sourcing: today's Keepers batch goes to an assistant's queue.
export default function SendKeepers({ batchIds, count, testid }) {
  const [listers, setListers] = useState(null);
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/photo-batches/listers").then(({ data }) => setListers(data.listers || [])).catch(() => setListers([])); }, []);
  if (!listers?.length || !batchIds?.length) return null;
  const send = async (id) => {
    setBusy(true);
    try {
      let name = "";
      for (const b of batchIds) name = (await api.post(`/photo-batches/${b}/send-keepers`, { lister_id: id || null })).data.assigned_name;
      toast.success(`${count} keeper${count === 1 ? "" : "s"} sent to ${name || "your assistants"}`);
      setOpen(false);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Couldn't send the keepers");
    } finally { setBusy(false); }
  };
  if (!open) {
    return (
      <button type="button" onClick={() => (listers.length === 1 ? send(listers[0].id) : setOpen(true))} disabled={busy}
        className="inline-flex items-center gap-1.5 rounded-full bg-[#0053DA] px-3 py-1.5 text-xs font-semibold text-white transition-transform active:scale-95 disabled:opacity-60"
        data-testid={`${testid}-send`}>
        <Send className="h-3.5 w-3.5" /> {busy ? "Sending…" : listers.length === 1 ? `Send to ${listers[0].name}` : "Send to assistant"}
      </button>
    );
  }
  return (
    <select autoFocus defaultValue="pick" disabled={busy} onChange={(e) => send(e.target.value === "any" ? null : e.target.value)} onBlur={() => !busy && setOpen(false)}
      className="h-8 rounded-full border border-[#0053DA] bg-white px-2 text-xs text-slate-800" data-testid={`${testid}-send-pick`}>
      <option value="pick" disabled>Send keepers to…</option>
      <option value="any">Any assistant</option>
      {listers.map((m) => <option key={m.id} value={m.id}>{m.name}</option>)}
    </select>
  );
}
